function getDateDifference(
  date1Str: string,
  date2Str: string
): { timeUnit: string; value: number } {
  const date1 = new Date(date1Str);
  const date2 = new Date(date2Str);
  const diff = Math.abs(date1.getTime() - date2.getTime());

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) {
    return { timeUnit: `day${days > 1 ? 's' : ''}`, value: days };
  }
  if (hours > 0) {
    return { timeUnit: `hour${hours > 1 ? 's' : ''}`, value: hours };
  }
  if (minutes > 0) {
    return { timeUnit: `minute${minutes > 1 ? 's' : ''}`, value: minutes };
  }
  return { timeUnit: `second${seconds > 1 ? 's' : ''}`, value: seconds };
}

export default getDateDifference;
